import { ArcGisFeatureServerLayer } from "../../format/ags-symbolizer";

export = <ArcGisFeatureServerLayer.Symbol[]>
    // from https://developers.arcgis.com/javascript/3/samples/playground/main.html#/config=symbols/SimpleMarkerSymbol.json
    // chose this to learn how to render svg as a marker
    // next up: https://www.mapbox.com/maki-icons/
    [
        {
            "color": [
                255,
                255,
                255,
                64
            ],
            "size": 12,
            "angle": 0,
            "xoffset": 0,
            "yoffset": 0,
            "type": "esriSMS",
            "style": "esriSMSPath",
            "outline": {
                "color": [
                    0,
                    0,
                    0,
                    255
                ],
                "width": 1,
                "type": "esriSLS",
                "style": "esriSLSSolid"
            },
            "path": "M16,3.5c-4.142,0-7.5,3.358-7.5,7.5c0,4.143,7.5,18.121,7.5,18.121S23.5,15.143,23.5,11C23.5,6.858,20.143,3.5,16,3.5z M16,14.584c-1.979,0-3.584-1.604-3.584-3.584S14.021,7.416,16,7.416S19.584,9.021,19.584,11S17.979,14.584,16,14.584z"
        }
    ];